// The day's figures on Tasks (pipeline TL2; BUGS.md TK40, TK21, TK23). Pure, and the only place they are worked out.
//
// Until 7 Oct each look counted for itself: My list counted its own list with Cobrain's proposals in and the long
// overdue out, Structure took the server's tally of accepted tasks, and Board and Team headed their filter bar with a
// total of their own. On live the same tasks read 13 overdue and 8 due today on My list, 1 and 3 on Structure. Mike
// chose "Yours first" (module 10 U374): the figures are the reader's own tasks, never Cobrain's proposals, and every
// look takes them from here over the same rows, so they cannot disagree.
import { dueKind } from './when.js';

/** What the figures need of a task. A proposal (status 'suggested') is not the reader's until accepted (D60). */
export interface Countable {
  status: string; ownerId: string; delegateId: string | null; dueAt: string; duePrecision: string;
  asked: readonly unknown[]; askedBy: unknown | null;
}

/** A task the reader holds: their own, one handed to them, or one put to them to take (U298). Open: not done. */
export function isYours(r: Countable, me: string): boolean {
  return r.status !== 'suggested' && (r.ownerId === me || r.delegateId === me || r.askedBy !== null);
}

export interface Figures { open: number; overdue: number; today: number; withOthers: number }

/**
 * The reader's open tasks, how many are overdue (the long overdue and the parked included: they are still overdue),
 * how many fall due today, and how many of their own are with someone else (handed on, or asked of a colleague and
 * not yet taken). `meOf` gives the reader's principal in the task's own store.
 */
export function figuresOf<T extends Countable>(rows: readonly T[], meOf: (r: T) => string, now: number = Date.now()): Figures {
  const open = rows.filter((r) => r.status !== 'done' && isYours(r, meOf(r)));
  return {
    open: open.length,
    overdue: open.filter((r) => dueKind(r.dueAt, r.duePrecision, now) === 'overdue').length,
    today: open.filter((r) => dueKind(r.dueAt, r.duePrecision, now) === 'today').length,
    withOthers: open.filter((r) => r.ownerId === meOf(r) && ((r.delegateId !== null && r.delegateId !== meOf(r)) || r.asked.length > 0)).length,
  };
}
